import { render } from "./DetalhesLote.vue?vue&type=template&id=4cacffec&scoped=true"
import script from "./DetalhesLote.vue?vue&type=script&lang=js"
export * from "./DetalhesLote.vue?vue&type=script&lang=js"

import "./DetalhesLote.vue?vue&type=style&index=0&id=4cacffec&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cacffec"]])

export default __exports__